import { ActionIcon, ActionIconProps, Avatar, Tooltip } from "@mantine/core";
import styled from "styled-components";

const TableInfoButton = ({ onClick }: any) => {
  return (
    <div onClick={onClick}>
      <Tooltip label="Daha fazlası için tıklayınız.">
        <StyledActionIcon radius={50} size={40}>
          <Avatar src={"/assets/infoIcon.png"} radius={0} size={24} />
        </StyledActionIcon>
      </Tooltip>
    </div>
  );
};
export default TableInfoButton;

const StyledActionIcon = styled(ActionIcon)<ActionIconProps>`
  background: transparent;
  &:hover {
    background: #e9eef1;
  }
`;
